import { Component, TemplateRef, ViewChild } from "@angular/core";
import { InterviewerLoginComponent } from "../interviewer/interviewer-login/interviewer-login.component";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { LoginDataService } from "../login-data.service";
import { Router } from "@angular/router";
import { VendorService } from "../services/vendor.service";
import { AuthService } from "../services/auth.service";
import { UtilsService } from "../utils.service";
import { EncryptionService } from "../encryption.service";
import { AdminService } from "../services/admin.service";


@Component({
  selector: "app-common-login",
  templateUrl: "./common-login.component.html",
  styleUrl: "./common-login.component.scss",
})
export class CommonLoginComponent {
  adminLoginForm: FormGroup;
  agentLoginForm: FormGroup;
  showpassword: boolean = false;
  dialogRef: MatDialogRef<any>;
  form: FormGroup;
  vendorData: any;
  enableChipControl = new FormControl(true);
  selectChipControl = new FormControl();

  selectedChip: string | null = null;
  selectable: boolean

  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  // showpassword: boolean = true;
  @ViewChild("popupTemplate") popupTemplate: TemplateRef<any>;
  vendorPasswordhide = true;
  interviewerPasswordhide = true;


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loginDataService: LoginDataService,
    private dialog: MatDialog,
    private vendorService: VendorService,
    private adminService: AdminService,
    private authService: AuthService,
    private utilsService: UtilsService,
    private encryptionService: EncryptionService,

  ) {
    this.adminLoginForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: this.fb.control("", [Validators.required]),
      role: ["", [Validators.required]],
    });

    this.form = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: this.fb.control("", [Validators.required]),
    });
    this.vendorService.vendorIdSubject$.subscribe(obj => {
      this.vendorData = obj;
      console.log("bbbb", obj);
    });
    this.agentLoginForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      p: this.fb.control("", [Validators.required]),
      
    });
  }

  goTo(link: any) {
    this.router.navigate([link]);
  }

  validateInterviewer() {
    let reqObj = {
      email: this.form.value["email"],
      // password: this.form.value["password"],
      p: this.encryptionService.encrypt256(this.form.value["password"])

    };
    console.log("Form", this.form.value);
    console.log("reqObj", reqObj);
    // return;

    this.vendorService.validateInterviewer(reqObj).subscribe((resp: any) => {
      console.log("VENDOR DATA:::::::", resp);

      if (resp.statusCode == 200) {
        // this.router.navigate(["admin/"]);
        // console.log("========ADMIN DATA===========",resp.data)
        this.utilsService.setLoggedInStatus({
          loginStatus: true,
          role: resp.data.role,
          profileData: resp.data,
        });
        this.authService.roles.push(resp.data.role);
        // this.utilsService. = resp.data;
        this.vendorService.setInterviewerDetails(resp.data);
        this.authService.setLoggedIn(true);
        // this.authService.setLoggedIn(true);
        this.router.navigate(["/interviewer"]);
        // console.log("success");
      }
    });
  }

  validateAgent(){
    let reqObj = {
      email: this.form.value["email"],
      // password: this.form.value["password"],
      p: this.encryptionService.encrypt256(this.form.value["password"])
    };

    this.adminService.validateAgent(reqObj).subscribe((resp: any) => {
      console.log("VENDOR DATA:::::::", resp);

      if (resp.statusCode == 200) {
        // this.router.navigate(["admin/"]);
        // console.log("========ADMIN DATA===========",resp.data)
        this.utilsService.setLoggedInStatus({
          loginStatus: true,
          role: resp.data.role,
          profileData: resp.data,
        });
        this.authService.roles.push(resp.data.role);
        this.utilsService.token = resp.token

        // this.utilsService. = resp.data;
        // this.adminService.setInterviewerDetails(resp.data);
        this.authService.setLoggedIn(true);
        // this.authService.setLoggedIn(true);
        this.router.navigate(['admin/agents-console']);
        this.getAgentDetails()
        // console.log("success");
      }
    });
  }

  getAgentDetails() {
    let reqObj = {};
    console.log('From', this.form.value);
    console.log('reqObj', reqObj);
    this.adminService.getAgentDetails(reqObj).subscribe((resp: any) => {
      console.log('Company details Created success', resp);
      if (resp.statusCode == 200) {
        // this.setAgentProfile(resp.data);
      }
    });
  }

  toggleShow(event: Event) {
    event.preventDefault();
    this.showpassword = !this.showpassword;
  }

  onSubmit() {
    if (this.adminLoginForm.invalid) {
      this.adminLoginForm.markAllAsTouched();
      return;
    }
    this.validateVendor();
  }


  onForgotPasswordClick() {
    this.router.navigate(["forgot-password"]);
  }

  async validateVendor() {
    if (this.adminLoginForm.invalid) {
      this.adminLoginForm.markAllAsTouched();
      return;
    }
    const email = this.adminLoginForm.value["email"];
    // const password = this.adminLoginForm.value["password"];
    const p = this.encryptionService.encrypt256(this.adminLoginForm.value["password"])

    const role = this.adminLoginForm.value["role"];

    const data = await this.loginDataService.validateVendor(email, p, role);
    console.log("ppp", data);
    if (data.role === "VENDOR_EMP") {

      this.router.navigate(["vendor/employee/console"]);
    } else {
      this.router.navigate(["/vendor"]);

    }
    // subscribe(
    // (resp: any) => {
    //   // try {
    //   //   // const vendorData = this.loginDataService.handleLoginSuccess(resp);
    //     // console.log("Vendor Data:", vendorData);
    //     this.router.navigate(["/vendor"]);
    //   // } catch (error) {
    //   //   console.error("Error during login success handling:", error);
    //   // }
    // },
    // (error) => {
    //   console.error("Error during login", error);
    // }
    // );
  }
  // generateEmailOTP() {
  //   let reqObj = {
  //     "uuid": this.vendorData.uuid,
  //     email: this.vendorData.email
  //   };
  //   this.vendorService.generateEmailOTP(reqObj).subscribe((response: any) => {
  //     if (response.statusCode == 200) {

  //       this.snackbarService.open(response.supportMessage, 'close', 5000, "center", "top")

  //     }
  //   });

  // }
  // openEmailConfirmationDialog(): void {
  //   const dialogRef = this.dialog.open(this.confirmationDialog, {
  //     width: '45rem',
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       console.log('Ok clicked');
  //      this.generateEmailOTP();
  //     } else {
  //       console.log('Cancel clicked');
  //     }
  //   });
  // }

}
